.two-line {
    margin-bottom: 24px;
}

.label {
    height: 24px;
}

.label > *:first-child {
    font-size: 12px;
    font-weight: 500;
}

.label > *:not(:first-child) {
    font-size: 12px;
    padding: 0;
}
